import React from 'react';
import CheckBox from 'devextreme-react/check-box';
import DataModelView from '../../common/view/DataModelView';

export default class OfferSelectSummaryView extends DataModelView {
    getIntegratedPropertyNames() {
        return [
            'isNotifyEnabled',
            'isEmailCheckboxVisible'
        ];
    }

    render() {
        return (
            <div>
                <table className="pwx-horiz-center" width="100%"><tbody>
                    <tr>
                        <td className="pwx-button-container" align="left">
                            <CheckBox
                                text="Submit without email"
                                value={this.state.isNotifyEnabled}
                                onValueChanged={this.onNotifyEnabledChanged.bind(this)}
                                visible={this.state.isEmailCheckboxVisible}
                            />
                        </td>
                    </tr>
                </tbody></table>
            </div>
        );
    }

    onNotifyEnabledChanged(event) {
        this.dataModel.updateProperties({
            isNotifyEnabled: event.value
        });
    }
}